export default {
      id: "vehicule-usage",
      viewBox: "0 0 18 16",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#vehicule",
      toString: function () {
        return this.url;
      }
    }